import React from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Badge, Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

const TestimonialCard = ({
  university,
  studentName,
  description,
  achievement,
  course,
  imgLogo,
}) => {
  return (
    <div className="testimonial-grid">
      <Card className="testimonial-preview rounded">
        <CardBody>
          <h4>{university}</h4>
          <img src={require("../../assets/img/" + imgLogo)} alt=" " />
          <p className="mt-2">
            <Badge color="light" className="otm-badge">
              {studentName}
            </Badge>
            <Badge color="primary" className="otm-badge-dark">
              {achievement}
            </Badge>
          </p>
        </CardBody>
      </Card>
      <Card className="testimonial-detail rounded">
        <CardBody className="row">
          <div className="col-4">
            <img src={require("../../assets/img/" + imgLogo)} alt=" " />
          </div>
          <div className="col-8 detail-right">
            <h4>{university}</h4>
            <p>
              <Badge color="light">{course}</Badge>
            </p>
            <p>
              <Badge color="light" className="otm-badge">
                {studentName}
              </Badge>
              <Badge color="primary" className="otm-badge-dark">
                {achievement}
              </Badge>
            </p>
          </div>
          <div className="col-md-12 detail-below">
            <span className="testimonial-quote">
              <FontAwesomeIcon icon={faQuoteLeft} />
            </span>
            <p>{description}</p>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

TestimonialCard.propTypes = {
  university: PropTypes.string.isRequired,
  studentName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  achievement: PropTypes.string.isRequired,
  course: PropTypes.string,
  imgLogo: PropTypes.string.isRequired,
};

TestimonialCard.defaultProps = {
  course: "",
};

export default TestimonialCard;
